export default __webpack_public_path__ + "static/services-tests-audits-7d3cc3f8d034c2eb5349b2fe6f0be87b.jpg";